import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Content.module.scss'

/**
 * The `Content`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Content = forwardRef((props, forwardedRef) => {
  const { children, className } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames([className, lineItemStyles.content, styles.content]),
    [className]
  )

  return (
    <div ref={ref} className={classNameOutput}>
      {children}
    </div>
  )
})

// Display name
Content.displayName = 'Content'

Content.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

Content.defaultProps = {
  children: null,
  className: ''
}

// Memoize
export default memo(Content)
